import PropTypes from "prop-types";
import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import ErrorMessage from "Signups/FamilyRegistration/Shared/ErrorMessage";
import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";

import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";
import FnrLoadingBricks from "UI/FnrLoadingBricks";

import DeletionConfirmation from "./DeletionConfirmation";
import Description from "./Description";

ProfileFieldCheckboxItem.proptype = {
  setting: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  style: PropTypes.object,
  onPointerDown: PropTypes.func,
  itemRef: PropTypes.object,
  isActiveItem: PropTypes.bool,
};
function ProfileFieldCheckboxItem({
  setting,
  item,
  style,
  onPointerDown,
  itemRef,
  disabled,
}) {
  const deleteBtnRef = useRef();

  const { updateSetting, saving, error, setError } = useUpdateSetting();
  const {
    enabled,
    order,
    ID,
    title,
    canReorder,
    canEditDescription,
    canDelete,
    isRequired,
  } = item;

  const canToggle = canReorder;

  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  const handleToggle = () => {
    setError(false);
    updateSetting({
      setting: setting,
      itemID: ID,
      value: !enabled,
      action: "toggle",
    });
  };

  const handleDelete = () => {
    updateSetting({
      setting: setting,
      itemID: ID,
      value: null,
      action: "delete",
    });
  };

  const triggerDeleteConfirmation = () => {
    setError(false);
    setShowDeleteConfirmation(true);
  };

  const id = title.split(" ").join("_").toLowerCase();
  const isDisabled = saving || !canToggle || disabled || isRequired;

  return (
    <>
      <Wrapper ref={itemRef} style={style}>
        <CheckboxWrapper>
          {saving ? (
            <FnrLoadingBricks show={saving} size={20} />
          ) : (
            <FnrCheckbox
              on={enabled}
              toggleOn={handleToggle}
              id={`${setting}-${id}`}
              color={isDisabled ? "rgb(176, 176, 176)" : "#016099"}
              disabled={isDisabled}
            />
          )}
        </CheckboxWrapper>

        <Description
          description={title}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          membershipStatusID={ID}
          canEditDescription={canEditDescription}
          isGrayText={
            saving || (!canDelete && !canReorder && !canEditDescription)
          }
        />
        <IconGrid>
          {canEditDescription ? (
            <Edit
              onClick={() => {
                setError(null);
                setIsEditing((isEditing) => !isEditing);
              }}
            >
              <i className="far fa-pencil-alt" style={{ color: "#B0B0B0" }} />
            </Edit>
          ) : null}
          {canReorder ? (
            <Reorder
              onPointerDown={(e) => {
                setError(null);
                onPointerDown(e);
              }}
            >
              <i className="fas fa-sort" style={{ color: "#B0B0B0" }} />
            </Reorder>
          ) : null}
          {canDelete ? (
            <Delete ref={deleteBtnRef} onClick={triggerDeleteConfirmation}>
              <i className="far fa-trash-alt" style={{ color: "#B0B0B0" }} />
            </Delete>
          ) : null}
        </IconGrid>
        <DeletionConfirmation
          buttonRef={deleteBtnRef}
          show={showDeleteConfirmation}
          setShow={setShowDeleteConfirmation}
          description={title}
          handleDelete={handleDelete}
        />
      </Wrapper>
      <ErrorMessage error={error?.error} marginLeft="10px" />
    </>
  );
}

export const AdultProfileFieldCheckboxItem = (props) => {
  return <ProfileFieldCheckboxItem setting="extendedFieldsAdults" {...props} />;
};
export const ChildrenProfileFieldCheckboxItem = (props) => {
  return (
    <ProfileFieldCheckboxItem setting="extendedFieldsChildren" {...props} />
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f1f4f6;
  border-radius: 6px;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 28px;
`;

const IconGrid = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  ${Wrapper}:hover & {
    opacity: 1;
  }
`;

const IconContainer = styled.div`
  cursor: pointer;
`;

const Edit = styled(IconContainer)``;

const Reorder = styled(IconContainer)`
  user-select: none;
  cursor: move;
  cursor: grab;
  touch-action: none;

  &:active {
    cursor: move;
    cursor: grabbing;
  }
`;

const Delete = styled(IconContainer)`
  position: relative;
`;
